module.exports = __webpack_public_path__ + "img/long-neck-4.0ed5f95e.webp";